export default __webpack_public_path__ + "static/media/Logo.8b53b5e7.svg";